import { h, ComponentChildren, JSX, Ref } from "preact";

import classname from "../../../foundation/utils/classname";
import IconLoading from "../Icons/IconLoading";

import styles from "./NinjaTextButton.module.css";

type NativeButtonProps = JSX.HTMLAttributes<HTMLButtonElement>;

enum Display {
    Inline = "inline",
    Block = "block"
}

interface Props extends NativeButtonProps {
    buttonRef?: Ref<HTMLButtonElement>;
    textClass?: string; /* Class of the text style. Example: "body-1", "caption-1 medium" */
    display?: Display;
    children?: ComponentChildren;
    isPending?: boolean;
    onClick?: (event: MouseEvent) => void;
}

function NinjaTextButton({
    buttonRef,
    class: cssClass,
    textClass = "body-1 medium",
    display = Display.Block,
    children,
    isPending,
    onClick,
    ...nativeButtonProps
}: Props) {
    return (
        <button
            {...nativeButtonProps}
            class={classname(textClass, styles.ninjaTextButton, cssClass, styles[display], {
                [styles.pending]: isPending
            })}
            ref={buttonRef}
            disabled={nativeButtonProps.disabled || isPending}
            onClick={onClick}>
            {children}
            {isPending && (
                <div class={styles.pendingContainer}>
                    <IconLoading class="spinning"/>
                </div>
            )}
        </button>
    );
}

export default NinjaTextButton;
export {
    Props as NinjaTextButtonProps,
    Display as NinjaTextButtonDisplay
};
